import React, { useCallback, useEffect, useState } from 'react';
import { CloseIcon, Ie11BannerWrapper } from './Ie11Banner.styles';
import Icon from '../../../Shared/Icons';
import Cookie from '../../../services/Cookie';

const Ie11Banner = () => {
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    if (Cookie.getCookie('hasClosedIe11Banner')) setIsClosed(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsClosed(true);
    Cookie.setCookie('hasClosedIe11Banner', true);
  });

  return !isClosed
    && (
      <Ie11BannerWrapper>
        <div>
          The browser you are using is unsupported. Need a recommendation?&nbsp;
        </div>
        <div>
          <a target="_blank" href="https://www.google.com/chrome/">
            {' '}
            The latest version of Chrome
          </a>{' '}
          is supported on all devices.
        </div>
        <CloseIcon onClick={handleClose}>
          <Icon iconName="close" />
        </CloseIcon>
      </Ie11BannerWrapper>
    );
};

export default Ie11Banner;
